import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardNav from "../../components/Header";
import SortIcon from "@material-ui/icons/Sort";
import { Route, useHistory } from "react-router-dom";
import Icon from "@material-ui/core/Icon";
//importing component
import Home from "../home/Home";
import { useDispatch, useSelector } from 'react-redux';
import { UserBuyCities } from "../../redux/action/user";

import BuyCity from '../home/buyCity'
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(9),
    [theme.breakpoints.down("md")]: {
      marginLeft: theme.spacing(5),
    }
    ,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  rootOpened: {
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    // whiteSpace: "nowrap",
    zIndex: 400,
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
    }),
    backgroundColor: theme.sideBarColor,
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      transitionDuration: { enter: 3000, exit: 3000 },
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: theme.sideBarColor,
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),

  },
}));

export default function MiniDrawer({ aut, useraccount, contract }) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [isKeyMatched, setIsKeyMatched] = useState(0);
  const history = useHistory();
  const { pathname } = history.location;
  const dispatch = useDispatch()
  const rOutes = [
    {
      name: "Dashboard",
      link: "/dashboard",
      Img: "home",
      activeImg: "home",
    },

    {
      name: "Message",
      link: "/dashboard/message",
      Img: "email",
      activeImg: "email",
    },

    {
      name: "Accounts",
      link: "/dashboard/account",
      Img: "perm_identity",
      activeImg: "perm_identity",
    },

    {
      name: "Resseling",
      link: "/dashboard/reselling",
      Img: "pie_chart",
      activeImg: "pie_chart",
    },

    {
      name: "Reports",
      link: "/dashboard/reports",
      Img: "warning",
      activeImg: "warning",
    },
  ];


  const Aut = useSelector(state => state.AutReducer)

  React.useEffect(() => {
    if (Aut.loinAddress.find == true) {
      dispatch(UserBuyCities(Aut.loinAddress))
    } else if (Aut.loinAddress.find == false) {
      history.push('/login')
    }
    else {
      history.push('/login')
    }
  }, [Aut.loinAddress.find == true])

  return (
    <div
      className={`${open ? classes.rootOpened : classes.root} dashboard-home`}
    // style={{ background: "#102D4D" }}
    >
      <CssBaseline />

      <DashboardNav position="fixed" dashboard />

      {/* </AppBar> */}
      <Drawer width={200} openSecondary={true}

        variant="permanent"
        className={clsx(classes.drawer, {
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <List>
          <ListItem button>
            <ListItemIcon onClick={() => setOpen(!open)}>
              <SortIcon style={{ color: "white" }} />
            </ListItemIcon>
            <ListItemText />
          </ListItem>
        </List>
        <Divider />
        <List>
          {rOutes.map((route, index) => (
            <ListItem
              button
              onClick={() => {
                history.push(route.link);
                setIsKeyMatched(index);
                setOpen(false)
              }}
              style={{
                backgroundColor: route.link === pathname && theme.blueColor,
                borderLeft:
                  route.link === pathname && `3px solid ${theme.lightBlue}`,
              }}
            >
              <ListItemIcon>
                <Icon style={{ color: theme.lightBlue }} rounded>
                  {route.link === pathname ? (
                    route.activeImg
                  ) : (
                    <Icon style={{ color: "#9d9ea0" }}> {route.Img}</Icon>
                  )}
                </Icon>
              </ListItemIcon>
              <ListItemText
                style={{
                  color:
                    route.link === pathname
                      ? theme.lightBlue
                      : theme.dashboardRoutesColor,
                }}
                primary={route.name}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>

      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Route exact path={`/dashboard`} component={Home} />

        <Route exact path={`/dashboard/city/:id`} component={BuyCity} />

        <Route exact path={`/dashboard/account`} component={Home} />

        <Route exact path={`/dashboard/reselling`} component={Home} />

        <Route exact path={`/dashboard/reports`} component={Home} />
      </main>
    </div>
  );
}
